
import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Alert, Badge, Col, Container, Form, Image, InputGroup, Row, Spinner, Table } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { LinkContainer } from 'react-router-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { LoginInfo } from '../App';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";
import Masonry from 'react-masonry-css';
import Tile from './common/Tile';
import Thumb from './common/Thumb';
import { isLoggin, updateRenzoku, updateTile } from '../service/LoginService';
import { arrayShuffle } from '../service/CommonUtil';
import { Button, Skeleton, Tab, Tabs } from '@mui/material';
import CommonDialog from './common/CommonDialog';
import UserMark from './UserMark';

const RankingOthers = () => {
    async function getImage(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/ranking/").then((r)=>r.json().then((json)=>{
            return json
        }))
    }

    const {t,i18n} = useTranslation()
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
    // ナビゲーション
    const navigate = useNavigate()

    useEffect(() => {
        if(loginInfo.result){
            // 連続投稿の表示減らす
            setOmitContinuous(loginInfo.renzoku === 1)
            // タイルモード
            setTileMode(loginInfo.tile === 1)
        }
    },[loginInfo])

    const [imageList,setImageList] = useState([])
    const [followUserImage,setFollowUserImage] = useState([...Array(0)])
    const [imagePage,setImagePage] = useState(1)
    const [loading,setLoading] = useState(true)

    // 投稿遅延ロード
    const options = {
        root: null,
        rootMargin: "0px",
        threshold: 0.05
    }
    const observer = new IntersectionObserver((entries,observer)=>{
        entries.forEach(entry => {
            if(entry.intersectionRatio > 0){
                const imgEl = entry.target;
                //imgEl.src = imgEl.dataset.src;          
                observer.unobserve(entry.target);
                // ロードした部分まで進んだら追加読み込み
                if(imgEl.dataset.no !== undefined && parseInt(imgEl.dataset.no) === (imagePage * 1000 - 1) ){
                    setImagePage(imagePage+1)
                }
              }
        })
    }, options);

    useEffect(() => {
        getImage().then(r => {
            if(r.result){
                if(r.data.length > 0){
                    setImageList(r.data)
                }
            }
            setLoading(false)
        })
    },[imagePage])

    useEffect(() => {
        // タイトル設定
        document.querySelector("title").textContent = "その他のランキング - アワートAI"
    },[])

    const [omitContinuous,setOmitContinuous] = useState(false)
    const [tileMode,setTileMode] = useState(true)
    const [showSetting,setShowSetting] = useState(false)

    // 画像遅延ロード
    useEffect(() => {
        //document.querySelectorAll(".lazy").forEach(e => observer.observe(e))
    },[imageList,followUserImage])

    // ダイアログ
    const [show, setShow] = useState(false);
    const [dialogTitle, setDialogTitle] = useState("");
    const [dialogMessage, setDialogMessage] = useState("");
    function dialog(title,message){
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
    }
    const breakpointColumnsObj = {
        default: 9,
        1800: 8,
        1600: 7,
        1400: 6,
        1200: 5,
        992: 4,
        768: 3,
        576: 2,
    }
    return(
    <div className="wrapper">
        <header className="App-header"></header>
        <CommonDialog open={show}
            content={dialogMessage}
            onClick={() => {
                setShow(false)
            }} onClose={() => setShow(false)}
            title={dialogTitle} />
        <Header />
        <Category />
        <div className='p-0' style={{position:"fixed",zIndex:2,width:"100%",top:"68px",backgroundColor:"inherit",overflow:"auto"}} id="category-bar">
            <div className='mt-1 mb-1' style={{width:"900px",fontSize:"24px",fontWeight:"bold",backgroundColor:"inherit"}}>
                <Tabs variant='fullWidth' onChange={(e) => {
                    switch(e.target.tabIndex){
                        case 0:
                            navigate("/")
                        break
                        case 1:
                            navigate("/new")
                        break
                        case 2:
                            navigate("/osusume")
                        break
                        case 3:
                            navigate("/ranking")
                        break
                        case 4:
                            navigate("/random")
                        break
                        case 5:
                            navigate("/newFollow")
                        break
                        case 6:
                            navigate("/newUser")
                        break
                    }
                    }} centered>
                    <Tab label={"Top"} value="0" tabIndex={0}></Tab>
                    <Tab label={t("home.new")} value="new" tabIndex={1} onClick={() => navigate("/new")}></Tab>
                    <Tab label={t("osusume.title")} value="osusume" tabIndex={2}></Tab>
                    <Tab label={t("category.ranking")} value="ranking" tabIndex={3}></Tab>
                    <Tab label={t("category.discover")} value="random" tabIndex={4}></Tab>
                    <Tab label={t("newFollow.title")} value="newFollow" tabIndex={5}></Tab>
                    <Tab label={t("newUser.title")} value="newUser" tabIndex={6}></Tab>
                </Tabs>
            </div>
        </div>
        <Container style={{marginTop:"140px"}}>
            <h5>その他のランキング</h5>
            <Button variant='contained' className='m-3'>1カ月の生成枚数</Button>
            {loading ? [... Array(15)].map((d,i) => <Skeleton width={"100%"} height={50} animation="wave" />) : (
                <Table striped bordered hover style={{width:"100%"}}>
                    <thead>
                        <tr><th>No</th><th>ユーザー名</th><th>生成枚数</th></tr>
                    </thead>
                    <tbody>
                        {imageList.map((d,i) => {
                            return <tr><td>{i+1}</td><td>{d.user_name}<UserMark plan={d.plan} sms_auth={d.sms_auth} dialog={() => window.location.href = "/legal"} /></td><td>{parseInt(d.count).toLocaleString()}</td></tr>
                        })}
                    </tbody>
                </Table>
            )}
        </Container>
        <Footer />
    </div>
    )
}

export default RankingOthers;
